module.exports = __webpack_public_path__ + "static/media/customer.1053c125.svg";